export default (urlParameters) => {
  return {
    ads_allowed: true,
    nc_wind_toggle_allowed: true
  }
}
